module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"submit":"Soumettre","cancel":"Annuler","title":"Création d’une nouvelle propriété","processing":"Traitement en cours...","uploadFiles":"Pièces jointes"}}')
  delete Component.options._Ctor
}
